import styled from 'styled-components'

export const StyledFormWrapper = styled.div`
  margin-bottom: 20px;

  .header {
    font-size: 16px !important;
    font-style: italic;
    font-weight: bold;
  }

  .form-divider {
    background: ${props => props.theme.firstColor};
    margin-top: -2px !important;
    border-top: 2px solid rgba(34,36,38,.15) !important;
  }
`

export const StyledAvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  padding: 10px;
`

export const StyledAvatarWrapper = styled.div`
  position: relative;
  width: 150px;
  height: 150px;

  &:hover .avatar-overlay {
    opacity: 1;
  }

  &:hover .avatar-image {
    transform: scale(1.02);
  }

  &:hover .delete-button {
    opacity: 1;
  }
`

export const StyledAvatarImage = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid ${props => props.theme.firstColor || '#2185d0'};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
`

export const StyledAvatarOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledDeleteButton = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background: #ff4d4f;
    transform: scale(1.1);

    i {
      color: #fff !important;
    }
  }

  i {
    margin: 0 !important;
    color: #ff4d4f !important;
    font-size: 14px !important;
  }
`

export const StyledFormSection = styled.div`
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: visible;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .section-header {
    background: linear-gradient(145deg, #f7f7f7, #fff);
    padding: 14px 18px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #e0e0e0;

    i.icon {
      margin: 0;
      color: ${props => props.theme.firstColor} !important;
      font-size: 18px;
    }

    .section-title {
      font-weight: 600;
      font-size: 15px !important;
      color: ${props => props.theme.firstColor} !important;
    }
  }

  .section-content {
    padding: 16px 18px;
    background-color: #fff;
    overflow: visible;
  }
`

export const StyledBasicInfoContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`

export const StyledFieldsContainer = styled.div`
  flex: 1;
  min-width: 0;
`
